import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const StyledRoot = styled.div(({ theme: { spaces, breakpoints } }) => ({
  marginTop: spaces.default,
  padding: `0 ${spaces.default / 2}px`,

  [`@media (min-width: ${breakpoints.medium})`]: {
    padding: `0px ${spaces.default}px`,
  },
}))

const StyledTextWrapper = styled.div(({ theme: { spaces, colors } }) => ({
  fontStyle: 'italic',
  padding: `${spaces.default}px 0`,
  borderTop: `1px solid ${colors.light_grey}`,
}))

const StyledText = styled.p(({ theme: { fontSize, colors } }) => ({
  fontSize: `${fontSize * 0.7}px`,
  lineHeight: `${fontSize * 0.7}px`,
  margin: 0,
  color: colors.mid_grey,
}))

const Disclaimer = ({
  label, dataTest,
}) => (label && (
  <StyledRoot>
    <StyledTextWrapper>
      <StyledText data-test={dataTest}>{label}</StyledText>
    </StyledTextWrapper>
  </StyledRoot>
))

Disclaimer.propTypes = {
  label: PropTypes.string,
  dataTest: PropTypes.string,
}

Disclaimer.defaultProps = {
  label: '',
  dataTest: '',
}

export default React.memo(Disclaimer)
